export default __webpack_public_path__ + "static/media/RobotoMono-Italic.4320ef8f.woff";